import { render, staticRenderFns } from "./zjservice.vue?vue&type=template&id=6697e96d&scoped=true&"
import script from "./zjservice.vue?vue&type=script&lang=js&"
export * from "./zjservice.vue?vue&type=script&lang=js&"
import style0 from "./zjservice.vue?vue&type=style&index=0&id=6697e96d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6697e96d",
  null
  
)

export default component.exports